import React, { useState } from "react";

export const FrecuentAskedQuestions = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = [
    {
      question: "How can i search for a Pokémon in the pokedex? ",
      answer:
        "You need to throw a Pokéball accurately (just press the Pokéball button or hit Enter on your keyboard",
    },
    {
      question: "How do Pokemon evolve?",
      answer:
        "Pokémon evolve by leveling up, using special items, or meeting certain conditions.",
    },
    {
      question: "What is a legendary Pokémon?",
      answer:
        "A legenday Pokémon is a rare and powerful Pokémon that usually appears only in a game.",
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="faq-container">
      <h2 className="faq-title">Frequently asked question</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <button className="faq-question" onClick={() => toggleFaq(index)}>
              {faq.question}
              <span className="faq-icon">
                {openIndex === index ? "▲" : "▼"}
              </span>
            </button>
            {openIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FrecuentAskedQuestions;
